import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import styles from "../PresentationsList.module.scss";

type ContextMenuProps = {
    anchorEl: HTMLElement;
    onDelete: () => void;
    onEdit: () => void;
};

export const ContextMenu = forwardRef<HTMLDivElement, ContextMenuProps>(
    ({ anchorEl, onDelete, onEdit }, ref) => {
        const { t } = useTranslation();
        const rect = anchorEl.getBoundingClientRect();

        return (
            <div
                ref={ref}
                className={styles.contextMenu}
                style={{
                    position: "fixed",
                    top: rect.bottom + 7,
                    right: window.innerWidth - rect.right,
                }}
            >
                <BottomBarItem onClick={onEdit}>{t("presentations.renameAction")}</BottomBarItem>
                <BottomBarItem onClick={onDelete}>{t("presentations.deleteAction")}</BottomBarItem>
            </div>
        );
    },
);
